import React, { useState, useEffect } from 'react'
import { Paper, Divider, Card } from '@mui/material'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import 'swiper/css/autoplay';
import 'swiper/css';
import api from '../../API/api';
import BlurCircularIcon from '@mui/icons-material/BlurCircular';



const AlumniSpeak = () => {

    const [alumni, setAlumni] = useState();

    useEffect(() => {
        getAlumni()
    }, []);

    const getAlumni = () => {
        api.getAlumni().then((res) => {
            // console.log(res);
            setAlumni(res.data.data)
        })
    }

    return (
        <>
            <div className='my-2'>
                <Paper elevation={3}>
                    <div className='p-5'>

                        <div className="text-center">
                            <h2> Alumni Speak </h2>
                        </div>
                        <div className='text-center pb-4'>
                            <i> <small> <BlurCircularIcon fontSize='small' /> Hear from our successful alumni  <BlurCircularIcon fontSize='small' /> Insights from accomplished professionals <BlurCircularIcon fontSize='small' /> Learn from those who have walked the same path</small></i>
                        </div>

                        <div className="row p-2">
                            <div className="col-12">
                                <div>
                                    <Swiper
                                        slidesPerView={3}
                                        // pagination={{ clickable: true }}
                                        spaceBetween={10}
                                        // loop={true}
                                        autoplay={true}
                                        navigation={{
                                            clickable: true,
                                            nextEl: '.review-swiper-button-next',
                                            prevEl: '.review-swiper-button-prev',
                                        }}
                                        modules={[Autoplay, Pagination, Navigation, Scrollbar]}
                                        className="testimonials-slider swiper"
                                        data-aos="fade-up"
                                        data-aos-delay="100"
                                        breakpoints={{
                                            // when window width is >= 640px
                                            460: {
                                                //   width: 640,
                                                slidesPerView: 1,
                                            },
                                            // when window width is >= 768px
                                            768: {
                                                //   width: 768,
                                                slidesPerView: 1,
                                            },
                                            968: {
                                                //   width: 768,
                                                slidesPerView: 3,
                                            },

                                        }}
                                    >



                                        {alumni && alumni.map((a) =>
                                        (

                                            <>
                                                {a.shortNote &&
                                                    <>
                                                        {a.shortNote !== 'undefined' &&

                                                            <SwiperSlide>
                                                                <div className="p-1">
                                                                    <Paper elevation={5} sx={{ borderRadius: '0%', minHeight: '250px' }} >
                                                                        <div className="m-2 p-2" style={{ minHeight: '250px' }}>
                                                                            <div className=''> <b> {a.name}</b> </div>
                                                                            <div className=''> <small> {a.course} ({a.batch})</small>
                                                                            </div>

                                                                            <hr className='m-0' />
                                                                            <div>
                                                                                <small>
                                                                                    {/* <b> */}
                                                                                    <i>
                                                                                        {a.shortNote}
                                                                                    </i>
                                                                                    {/* </b> */}
                                                                                </small>
                                                                            </div>

                                                                        </div>
                                                                    </Paper>
                                                                </div>
                                                            </SwiperSlide>
                                                        }
                                                    </>
                                                }

                                            </>

                                        )
                                        )}

                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </Paper>
            </div>
        </>
    )
}

export default AlumniSpeak;